export default "__VITE_ASSET__Dtg7knH2__"